module.exports = __webpack_public_path__ + "img/12000.70e72785.jpg";